const disableFields = $('[disable-fields]'), otherAddressRadio = $('input[type="radio"]'),
    closeLightbox = $('.lightbox-close'), statements = $('.approval-statements'),
    select = $('.select'), childbirthSchoolCheckbox = $('input[childbirth-school-checkbox]'),
    installment = $('.leftLink'), promoCode = $('.rightLink');

let activeSwitcher = $this => {
    $this.siblings('.switch').addClass('y');
    $this.siblings('span[data-answer="no"]').removeClass('active');
    $this.siblings('span[data-answer="yes"]').addClass('active');

    $this.prop('checked', true);
    $this.closest('.form--data').children('.hidden').slideDown().children('.textareaCounter').fadeIn(500);
}

let inactiveSwitcher = $this => {
    $this.siblings('.switch').removeClass('y');
    $this.siblings('span[data-answer="no"]').addClass('active');
    $this.siblings('span[data-answer="yes"]').removeClass('active');

    $this.prop('checked', false);
    $this.closest('.form--data').children('.hidden').slideUp().children('.textareaCounter').fadeOut(100);
}

let showHiddenFields = checked => {
    let isChecked = checked.is(':checked');

    if (isChecked) {
        checked.closest('fieldset').next().slideDown();
    } else {
        checked.closest('fieldset').next().slideUp();
    }
}

let activeDisableFields = $this => {
    let isChecked = $this.is(':checked'),
        inputs = $this.closest('.form--data').find('input[field-to-disable]');

    if (isChecked) {
        inputs.attr('disabled', 'disabled').val('');
        inputs.prev().removeClass('error');

        if (inputs.next('.errorBar')) {
            inputs.next('.errorBar').remove();
        }
    } else {
        inputs.removeAttr('disabled', 'disabled');
    }
}

let showHiddenFieldsCustom = checked => {
    let isChecked = checked.is(':checked');
    if (isChecked) {
        checked.closest('fieldset').parent().next().find('fieldset').slideDown();
    } else {
        checked.closest('fieldset').parent().next().find('fieldset').slideUp();
    }
}

let activeDisableFieldsCustom = $this => {
    let isChecked = $this.is(':checked'),
        inputs = $this.closest('.form--data').find('input[field-to-disable]');

    if (isChecked) {
        inputs.attr('disabled', 'disabled').val('');
        inputs.prev().removeClass('error');

        if (inputs.next('.errorBar')) {
            inputs.next('.errorBar').remove();
        }
    } else {
        inputs.removeAttr('disabled', 'disabled');
    }
}

let switcher = ($this, bool, type) => {
    if (type === 'switch') {
        if (bool) {
            inactiveSwitcher($this);
        } else {
            activeSwitcher($this);
        }
    } else if (type === 'yes' && bool === false) {
        activeSwitcher($this);
    } else if (type === 'no' && bool === true) {
        inactiveSwitcher($this);
    }
}

/* sprawdzenie, czy inputy wyłączające pola byly zaznaczone */

if (disableFields.length) {
    let type = disableFields.map(function () {
        return $(this).attr('disable-fields');
    }).get();

    for (let i = 0; i < type.length; i++) {
        activeDisableFields($(`[disable-fields='${type[i]}']`));
        showHiddenFields($(`[disable-fields='${type[i]}']`));
    }
}

if ($('.p__path--second').length) {


    // Summary mobile
    var sumCol = $('.summaryColumn');
    var closeCol = $('.closeSummary');
    $(closeCol).on('click', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(sumCol).removeClass('active');
            $('body').removeClass('unscroll');
        } else {
            $(this).addClass('active');
            $(sumCol).addClass('active');
            $('body').addClass('unscroll');
        }
    });

    var red = $('div.red');
    var blue = $('div.blue');
    var navy = $('div.navy');
    var gold = $('div.gold');
    var variant = $('label.variant_label');

    // Zaznaczanie zaznaczonych danych

    if ($('[data-var="service"]:checked')) {
        $('[data-var="service"]:checked').closest(variant).addClass('active').removeClass('inactive').siblings().removeClass('active').addClass('inactive');
    } else {
    }
    $(variant).on('click', function () {
        $(this).addClass('active').removeClass('inactive').siblings().removeClass('active').addClass('inactive');
        var attr = $(this).attr('for');
        $("#" + attr).prop("checked", true).trigger("change");

    });

    $(document).on('click', '.save', function () {
        $(this).fadeOut(300);
        $('.hiddenAbonament').addClass('active');
    });

    $(document).on('click', '#labs-link', function () {
        $('#labs-list').toggleClass('active');
        $('#labs-link').toggleClass('active');
    });

    $(document).on('click', '.open_icon', function () {
        if ($(this).closest('.option').next('.info').hasClass('active')) {
            $(this).removeClass('active');
            $(this).closest('.option').next('.info').removeClass('active');
        } else {
            $('.open_icon').removeClass('active');
            $('.info').removeClass('active');
            $(this).addClass('active');
            $(this).closest('.option').next('.info').addClass('active');
        }
    });

    $(document).on('click', '.info p', function () {
        $('.open_icon').removeClass('active');
        $('.info').removeClass('active');
    });

    $(document).on('click', '.open_ktg', function () {
        if ($('.info_ktg').hasClass('active')) {
            $(this).removeClass('active');
            $('.info_ktg').removeClass('active');
        } else {
            $(this).addClass('active');
            $('.info_ktg').addClass('active');
        }
    });

    $(document).on('click', '.info_ktg .roll', function () {
        $('.open_ktg').removeClass('active');
        $('.info_ktg').removeClass('active');
    });

    $('<div class="quantity-button quantity-up"><i class="fa fa-plus-circle" aria-hidden="true"></i></div><div class="quantity-button quantity-down"><i class="fa fa-minus-circle" aria-hidden="true"></i></div>').insertAfter('.quantity input');
    $('.quantity').each(function () {
        var spinner = $(this),
            input = spinner.find('input[type="number"]'),
            btnUp = spinner.find('.quantity-up'),
            btnDown = spinner.find('.quantity-down'),
            min = input.attr('min'),
            max = input.attr('max');

        btnUp.click(function () {
            var oldValue = parseFloat(input.val());
            if (oldValue >= max) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue + 1;
                spinner.find("input").val(newVal);
                spinner.find("input").trigger("change");
            }

        });

        btnDown.click(function () {
            var oldValue = parseFloat(input.val());
            if (oldValue <= min) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue - 1;
                spinner.find("input").val(newVal);
                spinner.find("input").trigger("change");
            }

        });

    });

    checkAboYear();
    $('#app_conversion_path_second_step_years').on('change', function () {
        checkAboYear();
    });

    function checkAboYear() {
        if ($('#app_conversion_path_second_step_years').val() == 1) {
            $('.tooltip-inner').addClass('first');
            $('.tooltip-inner').removeClass('other');
        } else {
            $('.tooltip-inner').addClass('other');
            $('.tooltip-inner').removeClass('first');
        }
    }

// BG zaznaczonych pol po odswiezeniu/powrocie
    if ($('[name="app_conversion_path_second_step[_package]"]:checked').length) {
        var val = $('[name="app_conversion_path_second_step[_package]"]:checked').val();
        var current = "app_conversion_path_second_step__package_" + val;
        $("label[for='" + current + "']").addClass('active');
    }


    $(document).on('click', '.btn--change', function () {
        $('.ktg_lightbox').fadeIn();
        $('body').addClass('unscroll');
    });

    $('.p__path--variant_ktg').find('.data').removeClass('push-sm-1').removeClass('col-sm-4').addClass('col-sm-5');
    $('.p__path--variant_ktg').find('.variants').removeClass('push-sm-1');

    $(document).ready(function () {
        var storageYearsPaidChecked = $('[name="app_conversion_path_second_step[storageYearsPaid]"]:checked');

        if ($('#labs-list').find('input[type="radio"]:not(".default-transfer-country"):checked').length > 0) {
            $('a.resignation').addClass('active');
        }

        if (storageYearsPaidChecked.length > 0 && storageYearsPaidChecked.val() === '-1') {
            storageYearsPaidChecked.parent().addClass('active');
        }

        $(document).on('click', 'input[data-disabled="data-disabled"]', function (event) {
            event.preventDefault();
        });
    });

}

if ($(document).find('.p__path--variant_ktg').length || $(document).find('.ktg_lightbox').length) {

    if ($('[name="app_ktg_path_first_step[_ktgPackage]"]:checked').length) {
        var val = $('[name="app_ktg_path_first_step[_ktgPackage]"]:checked').val();
        var current = "app_ktg_path_first_step__ktgPackage_" + val;
        $("label[for='" + current + "']").addClass('active');
    }

    $(document).on('click', 'label.variant', function () {
        $(this).addClass('active').siblings().removeClass('active');
        var attr = $(this).attr('for');
        $("#" + attr).prop("checked", true).trigger("change");
    });
    $(document).on('click', '.returnForm, .ktg_lightbox .lightbox-close', function () {
        var ktgVariants = $('.flex, .basic, .elite');
        $('.lightbox_wrapper').fadeOut(500);
        $('body').removeClass('unscroll');
        $('#app_conversion_path_second_step_isKtg').prop("checked", false).trigger('change');
        ktgVariants.removeClass('error');
    });
    $(document).on('ktgPriceChange', function () {
        var val = $('[name="app_conversion_path_second_step[_ktgPackage]"]:checked').attr('data');
        var valPrice = $('[name="app_conversion_path_second_step[_ktgPackage]"]:checked').attr('dataPrice') + ' euro';
        $('#variantKtg').text(val);
        $('#ktgPrice').text(valPrice);
    });
    $(document).on('click', '.ktgSubmit', function () {
        var ktgVariants = $('.flex, .basic, .elite');
        if ($('[name="app_conversion_path_second_step[_ktgPackage]"]:checked').length) {
            ktgVariants.removeClass('error');
            $('.option_ktg > input').prop("checked", true).trigger("change");

            var val = $('[name="app_conversion_path_second_step[_ktgPackage]"]:checked').attr('data');
            var valPrice = $('[name="app_conversion_path_second_step[_ktgPackage]"]:checked').attr('dataPrice') + ' euro';
            $('#variantKtg').text(val);
            $('.chooseVar').fadeOut();
            $('#ktgPrice').text(valPrice).fadeIn();
            setTimeout(function () {
                $('.lightbox_wrapper').fadeOut(500);
                $('body').removeClass('unscroll');
            }, 250);

        } else {
            ktgVariants.addClass('error');
        }
    });

    // Zabezpieczenie podstawowych i plus Transplant Assistance
    $(document).on('change', 'input[data-code="optional.transplant"]', function () {
        var $basic = $('input[data-code="optional.transplant"]');
        var $extended = $('input[data-code="optional.transplant_plus"]');
        if ($extended.is(':checked')) {
            $extended.prop('checked', false);
        }
    });

    $(document).on('change', 'input[data-code="optional.transplant_plus"]', function () {
        var $basic = $('input[data-code="optional.transplant"]');
        var $extended = $('input[data-code="optional.transplant_plus"]');
        if ($basic.is(':checked')) {
            $basic.prop('checked', false);
        }
    });

    // Zabezpieczenie podstawowych i rzoszerzonych sznur
    $(document).on('change', 'input[data-code="optional.cord_tissue_isolation"]', function () {
        var $basic = $('input[data-code="optional.cord_tissue_isolation"]');
        var $extended = $('input[data-code="optional.cord_tissue_isolation_extended"]');
        if ($extended.is(':checked')) {
            $extended.prop('checked', false);
        }
    });

    $(document).on('change', 'input[data-code="optional.cord_tissue_isolation_extended"]', function () {
        var $basic = $('input[data-code="optional.cord_tissue_isolation"]');
        var $extended = $('input[data-code="optional.cord_tissue_isolation_extended"]');
        if ($basic.is(':checked')) {
            $basic.prop('checked', false);
        }
    });


    // Wywolanie home_ktg po zaznaczeniu checkboxa bez wybranego pakietu
    $(document).on("click", 'label[for="app_conversion_path_second_step_isKtg"]', function () {
        if ($('#app_conversion_path_second_step_isKtg').is(':checked')) {
        } else {
            $('.ktg_lightbox').css("display", "block").hide().fadeIn();
            $('body').addClass('unscroll');
        }
    });
}

if ($('.p__path-ktg--second')) {
    $(document).on('click', '#copyAddressMotherKtgSite', function () {
        function copyAddress(path_step, fromWho, type) {
            var street = $('#app_ktg_path_second_step_' + fromWho + '_address').val();
            var houseNr = $('#app_ktg_path_second_step_' + fromWho + '_houseNumber').val();
            var localNr = $('#app_ktg_path_second_step_' + fromWho + '_placeNumber').val();
            var postalCode = $('#app_ktg_path_second_step_' + fromWho + '_postalCode').val();
            var city = $('#app_ktg_path_second_step_' + fromWho + '_city').val();
            var country = $('#app_ktg_path_second_step_' + fromWho + '_country').val();
            var field = ['address', 'houseNumber', 'placeNumber', 'postalCode', 'city', 'country'];
            var valueField = [street, houseNr, localNr, postalCode, city, country];
            for (var i = 0; i < field.length; i++) {
                if (valueField[i] != '') {
                    if ($('#' + path_step + '_' + type + '_' + field[i]).attr('readonly') == 'readonly') {

                    } else {
                        $('#' + path_step + '_' + type + '_' + field[i]).val(valueField[i]).trigger('change');
                    }

                }
            }
        }

        if ($(this).attr('id') == 'copyAddressMotherKtgSite') {
            copyAddress('app_ktg_path_second_step', 'mother', 'ktgAddress');
        }
    });
}

if ($('.p__path--third').length) {
    $('#submit').on('click', function () {
        $('label').filter(function () {
            if ($(this).next().val() == "") {
                return true;
            }
        }).addClass('error');
    });

    $('.select--custom select').on('change', e => {
        $(e.target).parent().prev('label').removeClass('error');
    });

    $(document).on('click', '#copyAddressMotherKit, #copyAddressFatherKit, #copyAddressKoreKit, #copyAddress, #copyAddressMotherToChild, #copyAddressFatherToChild, #copyAddressChildToMother, #copyAddressChildToFather', function () {
        function copyAddress(path_step, fromWho, type) {
            var street = $('#app_conversion_path_third_step_' + fromWho + '_address').val();
            var houseNr = $('#app_conversion_path_third_step_' + fromWho + '_houseNumber').val();
            var localNr = $('#app_conversion_path_third_step_' + fromWho + '_placeNumber').val();
            var postalCode = $('#app_conversion_path_third_step_' + fromWho + '_postalCode').val();
            var city = $('#app_conversion_path_third_step_' + fromWho + '_city').val();
            var country = $('#app_conversion_path_third_step_' + fromWho + '_country').val();
            var field = ['address', 'houseNumber', 'placeNumber', 'postalCode', 'city', 'country'];
            var valueField = [street, houseNr, localNr, postalCode, city, country];
            for (var i = 0; i < field.length; i++) {
                if (valueField[i] != '') {
                    $('#' + path_step + '_' + type + '_' + field[i]).val(valueField[i]).trigger('change');
                }
            }
        }

        if ($(this).attr('id') == 'copyAddressMotherToChild') {
            copyAddress('app_conversion_path_third_step', 'mother', 'child');
        }

        if ($(this).attr('id') == 'copyAddressFatherToChild') {
            copyAddress('app_conversion_path_third_step', 'father', 'child');
        }

        if ($(this).attr('id') == 'copyAddressChildToMother') {
            copyAddress('app_conversion_path_third_step', 'child', 'mother');
        }

        if ($(this).attr('id') == 'copyAddressChildToFather') {
            copyAddress('app_conversion_path_third_step', 'child', 'father');
        }

        if ($(this).attr('id') == 'copyAddress') {
            copyAddress('app_conversion_path_third_step', 'mother', 'father');
        }
        if ($(this).attr('id') == 'copyAddressMotherKit') {
            copyAddress('app_conversion_path_third_step', 'mother', 'kitAddress');
        }
        if ($(this).attr('id') == 'copyAddressFatherKit') {
            copyAddress('app_conversion_path_third_step', 'father', 'kitAddress');
        }
        if ($(this).attr('id') == 'copyAddressKoreKit') {
            copyAddress('app_conversion_path_third_step', 'addressForCorrespondence', 'kitAddress');
        }
    });

    $(document).on('click', '#copyAddressMotherKtg, #copyAddressMotherKtgSite, #copyAddressFatherKtg, #copyAddressKoreKtg', function () {
        function copyAddress(path_step, fromWho, type) {
            var street = $('#app_conversion_path_third_step_' + fromWho + '_address').val();
            var houseNr = $('#app_conversion_path_third_step_' + fromWho + '_houseNumber').val();
            var localNr = $('#app_conversion_path_third_step_' + fromWho + '_placeNumber').val();
            var postalCode = $('#app_conversion_path_third_step_' + fromWho + '_postalCode').val();
            var city = $('#app_conversion_path_third_step_' + fromWho + '_city').val();
            var country = $('#app_conversion_path_third_step_' + fromWho + '_country').val();
            var field = ['address', 'houseNumber', 'placeNumber', 'postalCode', 'city', 'country'];
            var valueField = [street, houseNr, localNr, postalCode, city, country];
            for (var i = 0; i < field.length; i++) {
                if (valueField[i] != '') {
                    if ($('#' + path_step + '_' + type + '_' + field[i]).attr('readonly') == 'readonly') {

                    } else {
                        $('#' + path_step + '_' + type + '_' + field[i]).val(valueField[i]).trigger('change');
                    }

                }
            }
        }

        if ($(this).attr('id') == 'copyAddressMotherKtg') {
            copyAddress('app_conversion_path_third_step', 'mother', 'ktgAddress');
        }
        if ($(this).attr('id') == 'copyAddressMotherKtgSite') {
            copyAddress('app_ktg_path_second_step', 'mother', 'ktgAddress');
        }
        if ($(this).attr('id') == 'copyAddressFatherKtg') {
            copyAddress('app_conversion_path_third_step', 'father', 'ktgAddress');
        }
        if ($(this).attr('id') == 'copyAddressKoreKtg') {
            copyAddress('app_conversion_path_third_step', 'addressForCorrespondence', 'ktgAddress');
        }
    });

    $('#app_conversion_path_third_step_isMother').on('change', e => {
        $('.motherData .loader').fadeIn(300);
    });
    $('#app_conversion_path_third_step_isFather').on('change', e => {
        $('.fatherData .loader').fadeIn(300);
    });

    // usuwanie errorBara z selectow

    $('select').on("change", function () {
        $(this).next('.errorBar').remove();
    });
}

if ($('.childrenForm').length) {
    $('select').on("change", function () {
        $(this).next('.errorBar').remove();
        $(this).parent().prev().removeClass('error');
    });
}

// sprawdzanie czy zgody zostaly juz zaznaczone
if (statements.length) {
    (function (checkbox) {
        checkbox.siblings('.switch').addClass('y');
        checkbox.siblings('span[data-answer="no"]').removeClass('active');
        checkbox.siblings('span[data-answer="yes"]').addClass('active');
    }($('.switch--content input[checked="checked"]')));
}

$(document).on('change', '[name="app_conversion_path_third_step[addressForCorrespondenceType]"]', e => {
    let value = $(e.target).attr('value');

    if (value !== 'other') {
        $(e.target).closest('fieldset').parent().next().find('fieldset').slideUp();
        $('#copyAddressKoreKit').fadeOut(300);
        $('#copyAddressKoreKtg').fadeOut(300);
    } else {
        $('#copyAddressKoreKit').fadeIn(300);
        $('#copyAddressKoreKtg').fadeIn(300);
    }
});

$(document).on('change', 'input[disable-fields]', e => {
    showHiddenFields($(e.target));
    activeDisableFields($(e.target));
});

$(document).on('change', 'input[disable-fields-custom]', e => {
    showHiddenFieldsCustom($(e.target));
    activeDisableFieldsCustom($(e.target));
});

$(document).on('click', 'span[data-answer], .switch', e => {
    let input = $(e.target).siblings('input'),
        isChecked = input.is(':checked'),
        typeAnswer = $(e.target).attr('data-answer'),
        typeSwitch = $(e.target).attr('data-type');

    switcher(input, isChecked, typeAnswer || typeSwitch);
    input.trigger('change');
});

$(document).on('click touchstart', '.lightbox-close, .btn--check', e => {
    if ($(e.target).closest('.lightbox_wrapper').hasClass('second-1')) {
        $(e.target).closest('.lightbox_wrapper').fadeOut("normal", function () {
            $(this).remove();
        });
    } else {
        $(e.target).closest('.lightbox_wrapper').fadeOut();
    }

    if ($(e.target).closest('.lightbox_wrapper[indirect-step]')) {
        $(e.target).closest('.lightbox_wrapper[indirect-step]').fadeOut("normal", function () {
            $(this).remove();
        });
    }

    $('body').removeClass('unscroll');
});

select.on('change', e => {
    $(e.target).parent().prev().removeClass('error');
});

if ($('.p__path--fifth').length) {
    var fatherCont = $('#fatherCont');
    var motherCont = $('#motherCont');

    function isTouchDevice() {
        return typeof window.ontouchstart !== 'undefined';
    }

    if (isTouchDevice()) {
    } else {
        motherCont.remove();
        fatherCont.remove();
    }
}

installment.on('click', e => {
    if ($('input[name="app_conversion_path_second_step[_package]"]').is(':checked')) {
        $(e.target).toggleClass('active');
        $(e.target).next().removeClass('active');
        $(e.target).closest('.cost--summary').children('.promo-code').removeClass('active');
        $(e.target).closest('.cost--summary').children('.installment').toggleClass('active');
    } else {
        toastr.error(jsTranslations['messages']['choose_variant']);
    }


});

$('#closeInstallment').on('click', e => {
    installment.toggleClass('active');
    $(e.target).parent().parent('.installment').removeClass('active');
});

if (!$('.promo-code-activation').hasClass('active')) {
    promoCode.on('click', e => {
        if ($('input[name="app_conversion_path_second_step[_package]"]').is(':checked')) {
            $(e.target).toggleClass('active');
            $(e.target).prev().removeClass('active');
            $(e.target).closest('.cost--summary').children('.promo-code').toggleClass('active');
            $(e.target).closest('.cost--summary').children('.installment').removeClass('active');
        } else {
            toastr.error(jsTranslations['messages']['choose_variant']);
        }
    });
} else if ($('.promo-code-activation').hasClass('active')) {
    $('.promo-code').removeClass('active');
    promoCode.removeClass('active');
}

$(document).on('click', '[close-lightbox]', e => {
    $(e.target).closest('.lightbox_wrapper').fadeOut();
});

$(document).on('change', 'label + input', e => {
    $(e.target).prev('label').removeClass('error').next().next('.errorBar').remove();

});

if ($('body.mobile').length) {
    $(document).on("change", 'input[name="app_ktg_path_first_step[_ktgPackage]"]', function () {
        var data = $(this).attr('data');
        $('.' + data).addClass('active');
        if (data == 'flex') {
            $('.basic').removeClass('active');
            $('.elite').removeClass('active');
            $('.medical').removeClass('active');
        } else if (data == 'basic') {
            $('.flex').removeClass('active');
            $('.elite').removeClass('active');
            $('.medical').removeClass('active');
        } else if (data == 'elite') {
            $('.basic').removeClass('active');
            $('.flex').removeClass('active');
            $('.medical').removeClass('active');
        } else if (data == 'medical') {
            $('.basic').removeClass('active');
            $('.flex').removeClass('active');
            $('.elite').removeClass('active');
        }
    });
    $(document).on("change", 'input[name="app_conversion_path_second_step[_ktgPackage]"]', function () {
        var data = $(this).attr('data');
        $('.' + data).addClass('active');
        if (data == 'flex') {
            $('.basic').removeClass('active');
            $('.elite').removeClass('active');
        } else if (data == 'basic') {
            $('.flex').removeClass('active');
            $('.elite').removeClass('active');
        } else if (data == 'elite') {
            $('.basic').removeClass('active');
            $('.flex').removeClass('active');
        }
    });

    if ($('[name="app_ktg_path_first_step[_ktgPackage]"]:checked').length) {
        var val = $('[name="app_ktg_path_first_step[_ktgPackage]"]:checked').attr('data');
        $('.' + val).addClass('active');
    }
}

$(document).on('click', 'a[data-check-all="true"]', function (e) {
    e.preventDefault();
    var group = $(this).attr('data-group');
    var subgroup = $(this).attr('data-subgroup');

    $(document).find('#agreements_' + group + '_' + subgroup).find('.switch--content').each(function (index, switchContentElement) {
        let input = $(switchContentElement).find('input'),
            isChecked = false,
            typeSwitch = 'switch';


        switcher(input, isChecked, typeSwitch);
        input.trigger('change');

    });
});

$(document).on('click', '.step-second-2 .nav-link', function (e) {
    e.preventDefault();

    if (!$(this).hasClass('active')) {
        $(this).closest('.lightbox_content').find('.nav-item a.active').removeClass('active');
        $(this).addClass('active');
        var $target = $($(this).attr('href'));

        $target.parent().find('.show').removeClass('in active show');
        $target.addClass('in active show');
    }
});



// WEBPACK FOOTER //
// ./assets/js/pathUtils.js